require('./services/ApiService');
require('./services/ErrorService');
require('./services/HelperService');
require('./filters/GeneralFilters');

module.exports = {
  apiService: 'ace.apiService',
  errorService: 'ace.errorService',
  helperService: 'ace.helperService',
  generalFilters: 'ace.generalFilters',
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@homerjam/ace-angular/index.js
// module id = 54
// module chunks = 0